import * as React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PageNotFound() {
    return (
        <div className="wrapper">
            <Header />
            <div className="page404">
                <h1>Sorry, this page failed to load or no longer exists.</h1>
                <h4>You can try reloading the page, or start over above.</h4>
            </div>
            <Footer />
        </div>
    );
}
